export enum GROUP {
    METERING = 'METERING',
    CONSUMPTION_METER = 'CONSUMPTION_METER',
    PRODUCTION_METER = 'PRODUCTION_METER',
    INJECTION_METER = 'INJECTION_METER',
    SMART_ENERGY_METER = 'SMART_ENERGY_METER',
    GAS_METER = 'GAS_METER',
    ENERGY_STORAGE = 'ENERGY_STORAGE',
    SWITCH = 'SWITCH',
    BATTERY_SUPPLIED = 'BATTERY SUPPLIED',
    THERMOSTAT = 'THERMOSTAT',
    TEMPERATURE_METER = 'TEMPERATURE_METER',
    HVAC = 'HVAC',
    DETECTOR = 'DETECTOR',
    DOOR_WINDOW = 'DOOR_WINDOW',
    WATER = 'WATER',
    FIRE = 'FIRE',
    MOTION = 'MOTION',
}

export enum CONNECTIVITY_STATE {
    ONLINE = 'online',
    OFFLINE = 'offline',
    SLEEPING = 'sleeping'
}

export enum STATE_VAR {
    ACTIVE_POWER_A_PLUS = 'activePowerAplus',
    ACTIVE_POWER_A_MINUS = 'activePowerAminus',
    TOTAL_ACTIVE_ENERGY_A_MINUS = 'totalActiveEnergyAminus',
    CONNECTIVITY_STATE = 'connectivityState',
    OPERATION_MODE = 'operationMode',
    PROCESS_TEMP = 'processTemp',
    RELAY_STATE = 'relayState',
    SETPOINT = 'setpoint',
    SUPPORTED = 'supported',
    TEMPERATURE = 'temperature',
    VERTICAL_SWING = 'verticalSwing',
    HORIZONTAL_SWING = 'horizontalSwing',
    FAN_SPEED = 'fanSpeed'
}

export enum DeviceType {
    CONSUMPTION = 'consumption',
    GENERATION = 'generation',
    CLIMATIZATION = 'climatization',
    SENSORS = 'sensors'
}

export enum ClimatizationDeviceType {
    THERMOSTAT = 'Thermostat',
    AIR_CONDITIONING = 'Air Conditioning',
    TEMPERATURE = 'Temperature'
}

export enum SensorsDeviceType {
    DOOR_WINDOW = 'Door & Window',
    FLOOD = 'Flood',
    SMOKE = 'Smoke',
    MOTION = 'Motion'
}

interface TypeDef {
    order: Number;
    groups: GROUP[];
    nonGroups: GROUP[];
    subTypes?: any;
    properties?: any;
}

export class ClimatizationDeviceTypesMap {
    static map = new Map<ClimatizationDeviceType, TypeDef>()
    .set(ClimatizationDeviceType.TEMPERATURE, {
        order: 1,
        groups: [GROUP.TEMPERATURE_METER],
        nonGroups: [],
        properties: {
            icon: '/assets/img/icons/ic-sensor-temp.svg',
            connectivity: true
        }

    })
    .set(ClimatizationDeviceType.THERMOSTAT, {
        order: 2,
        groups: [GROUP.THERMOSTAT],
        nonGroups: [GROUP.HVAC],
        properties: {
            icon: '/assets/img/icons/ic-thermostat.svg',
            connectivity: true
        }
    })
    .set(ClimatizationDeviceType.AIR_CONDITIONING, {
        order: 3,
        groups: [GROUP.HVAC],
        nonGroups: [],
        properties: {
        }
    });
}

export class SensorsDeviceTypesMap {
    static map = new Map<SensorsDeviceType, TypeDef>()
    .set(SensorsDeviceType.DOOR_WINDOW, {
        order: 1,
        groups: [GROUP.DOOR_WINDOW],
        nonGroups: [],
        properties: {
        }
    })
    .set(SensorsDeviceType.FLOOD, {
        order: 2,
        groups: [GROUP.WATER],
        nonGroups: [],
        properties: {
        }
    })
    .set(SensorsDeviceType.SMOKE, {
        order: 3,
        groups: [GROUP.FIRE],
        nonGroups: [],
        properties: {
        }
    })
    .set(SensorsDeviceType.MOTION, {
        order: 3,
        groups: [GROUP.MOTION],
        nonGroups: [],
        properties: {
        }
    });
}

export class DeviceTypesMap {
    static map = new Map<DeviceType, TypeDef>()
        .set(DeviceType.CONSUMPTION, {
            order: 1,
            groups: [GROUP.CONSUMPTION_METER, GROUP.SWITCH],
            nonGroups: [GROUP.SMART_ENERGY_METER, GROUP.PRODUCTION_METER],
            properties: {
            }
        })
        .set(DeviceType.GENERATION, {
            order: 2,
            groups: [GROUP.PRODUCTION_METER],
            nonGroups: [],
            properties: {
            }
        })
        .set(DeviceType.CLIMATIZATION, {
            order: 3,
            groups: [GROUP.THERMOSTAT, GROUP.TEMPERATURE_METER, GROUP.HVAC],
            nonGroups: [],
            subTypes: ClimatizationDeviceTypesMap
        })
        .set(DeviceType.SENSORS, {
            order: 4,
            groups: [GROUP.DETECTOR],
            nonGroups: [],
            subTypes: SensorsDeviceTypesMap
        });
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/devices.constant.ts